import React, { useEffect } from "react";
import RoutesFile from "./RoutesFile";
import { createWeb3Modal, defaultConfig, useWeb3Modal } from "@web3modal/ethers/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";

// 1. Get projectId
const projectId = "427f264ae9f3224819db20738d71a386";

const BscNetwork = {
  chainId: 56,
  name: "Binance Smart Chain",
  currency: "BNB",
  explorerUrl: "https://bscscan.com/",
  rpcUrl: "https://bsc-mainnet.infura.io/v3/1406a70a28d04a059392c3e86c913b16",
};

// 3. Create a metadata object
const metadata = {
  name: "KindCat Staking",
  description: "Welcome to KindNest. Stake $KIND & earn $HUG. Hold $HUG and earn $ASTER!",
  url: "https://kindnest.xyz/", // origin must match your domain & subdomain
  icons: ["https://kindnest.xyz/kindlogo.png"],
};

// 4. Create Ethers config
const ethersConfig = defaultConfig({
  metadata,
});

// 5. Create a Web3Modal instance
createWeb3Modal({
  ethersConfig,
  chains: [BscNetwork],
  projectId,
  enableAnalytics: true,
});

function App() {
  const { isConnected, disconnect } = useWeb3Modal();

  useEffect(() => {
    if (isConnected) {
      // Auto disconnect after 10 minutes (600000 ms)
      const timer = setTimeout(() => {
        disconnect()
          .then(() => {
            toast.info("Wallet disconnected automatically after inactivity.");
          })
          .catch((error) => {
            toast.error(`Error disconnecting wallet: ${error.message}`);
          });
      }, 100000);

      return () => clearTimeout(timer);
    }
  }, [isConnected, disconnect]);

  return (
    <>
      <RoutesFile />
      <ToastContainer />
    </>
  );
}

export default App;
